module.exports = __webpack_public_path__ + "media/images/icons/bookmark-bb9167b1b0e7fbc41e2735f60d4d7152.svg";